<template>
  <div class="general-search-form">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12">
          <search-form
            ref="generalSearchForm"
            :showDates="$route.meta.showDates ? true : false"
            :showSearch="$route.meta.showSearch ? true : false"
            :searchHidden="$route.meta.searchHidden ? true : false"
            :tableDisplay="$route.meta.tableDisplay ? true : false"
            :allowNewObject="$route.meta.allowNewObject ? true : false"
            :allowExport="$route.meta.allowExport ? true : false"
            :showPaging="$route.meta.showPaging ? true : false"
            :options="{
              permalink: $route.meta.permalink
            }">
          </search-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import SearchForm from '@/components/SearchForm'
  export default {
    name: 'GeneralSearchPage',
    components: {
      SearchForm
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/admin/GeneralSearchPage.vue